<template>
  <footer class="page-footer">
    <div class="footer-bottom">
      <p>
        苏ICP备2022018765号
      </p>
      <!-- 浪潮项目备案号 -->
      <!-- <p>浙ICP备05074421号 浙公网安备33010602010295</p> -->
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PageFooter'
}
</script>

<style lang="scss" scoped>
.page-footer {
  width: 100%;
  height: 60px;
}

.footer-bottom {
  overflow: hidden;
  width: 100%;
  height: 30px;
  padding: 20px 0;
}

.footer-bottom p {
  // color: #ffffff;
  font-size: 12px;
  text-align: center;
  line-height: 39px;
}
</style>



// WEBPACK FOOTER //
// src/workspace/views/layout/Footer.vue